import { render, staticRenderFns } from "./UploadsPagination.vue?vue&type=template&id=b90bab54&scoped=true"
import script from "./UploadsPagination.vue?vue&type=script&lang=js"
export * from "./UploadsPagination.vue?vue&type=script&lang=js"
import style0 from "./UploadsPagination.vue?vue&type=style&index=0&id=b90bab54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90bab54",
  null
  
)

export default component.exports